var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
import { OnDestroy, OnInit } from '@angular/core';
import { DetailsService } from '../details.service';
import { parsePhoneNumberFromString } from 'libphonenumber-js';
import * as moment from 'moment';
import { Store } from '@ngrx/store';
import { getLimitsSelector } from '../../shared/limits/limits.reducer';
import { hideRecordingsNotAvailableInPlan } from '../../shared/limits/limitsHelper';
var EventDetailsComponent = /** @class */ (function () {
    function EventDetailsComponent(detailsService, store) {
        this.detailsService = detailsService;
        this.store = store;
        this.recordingEvents = [
            'REFUSE',
            'INCOMING_CALL',
            'INCOMING_CALL_ANSWERED',
            'INCOMING_CALL_REDIRECTED',
            'INCOMING_CALL_NOT_ANSWERED',
            'CONFERENCE_CALL',
            'TRANSFER_CALL'
        ];
        this.noRecordingsTypes = [
            'BUSY',
            'NOT_ANSWERED',
            'FAILED',
            'INCOMING_CALL_FAILED',
            'INCOMING_CALL_VOICEMAIL',
            'FAILED_CONNECT_AGENT'
        ];
        this.recordingsStorageDays = 0;
        this.eventFetchTimeoutId = null;
    }
    EventDetailsComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.detailsService.onSetEventId.subscribe(function (id) {
            _this.eventId = id;
        });
        this.store.select(getLimitsSelector).subscribe(function (limits) {
            _this.recordingsStorageDays = limits.recordingsStorageDays;
        });
        this.loadEvent();
    };
    EventDetailsComponent.prototype.ngOnDestroy = function () {
        if (this.eventFetchTimeoutId) {
            window.clearTimeout(this.eventFetchTimeoutId);
        }
    };
    EventDetailsComponent.prototype.loadEvent = function () {
        var _this = this;
        this.detailsService.getEventDetails(this.eventId).subscribe(function (eventDetail) {
            _this.event = hideRecordingsNotAvailableInPlan(_this.recordingsStorageDays, eventDetail);
            _this.spinnerVisible =
                !eventDetail.recordingAvailable &&
                    _this.recordingEvents.includes(_this.event.type) &&
                    !_this.noRecordingsTypes.includes(_this.event.finishType);
            if (_this.event && _this.event.contacts) {
                _this.assignedContacts = _this.event.contacts.map(function (item) {
                    var contactNumber = _this.getEmphasizedNumber(item.alternativeMsisdns);
                    var parsedNumber = parsePhoneNumberFromString(contactNumber);
                    return __assign({}, item, { extendedMsisdns: {
                            msisdn: contactNumber ? _this.detailsService.getFormatedNumber(contactNumber) : null,
                            isoCountry: contactNumber && parsedNumber && parsedNumber.country ? parsedNumber.country.toLowerCase() : null
                        } });
                });
            }
            if (_this.event && _this.event.callId) {
                _this.recordUrl = _this.detailsService.getRecordingUrl(_this.event.callId);
                _this.voiceMailFileName = _this.detailsService.createVoicemailFilename(_this.event);
            }
            _this.event.createdAt = moment(_this.event.createdAt).format('LTS,  L');
        });
        if (!this.event ||
            (this.event && this.recordingEvents.includes(this.event.type) && !this.event.recordingAvailable)) {
            this.eventFetchTimeoutId = setTimeout(function () {
                _this.loadEvent();
            }, 20000);
        }
    };
    EventDetailsComponent.prototype.getEmphasizedNumber = function (list, compareNumber) {
        if (compareNumber === void 0) { compareNumber = this.event.clientMsisdn; }
        var toCompare = compareNumber.replace(/\s/g, '');
        if (compareNumber) {
            return list.filter(function (number) { return number === toCompare; })[0];
        }
        else {
            return list[0];
        }
    };
    return EventDetailsComponent;
}());
export { EventDetailsComponent };
